function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.StateLoading", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["StateLoading"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var StateLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.8284 21.3284 13.5 20.5 13.5C19.6716 13.5 19 12.8284 19 12C19 8.13401 15.866 5 12 5Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = StateLoading;
});